module.exports = {
  platform: 'voice',
  name: 'prompt',
  node: 'prompt',
  bg: '#FFFFFF',
  note: '',
  property: {
    bot_says: []
  }
}
